<template>
  <div id="main">
    <CallCenterAlert v-if="showGlobalElements"></CallCenterAlert>
    <CallCenterHeader v-if="showGlobalElements"></CallCenterHeader>
    <div class="c-main">
      <transition
        name="o-transition__fade"
        mode="out-in"
        @beforeLeave="beforeLeave"
        @enter="enter"
        @afterEnter="afterEnter"
      >
        <router-view />
      </transition>
    </div>
    <CallCenterFooter v-if="showGlobalElements"></CallCenterFooter>
    <CallCenterLoadingIndicator :visible="loading" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
import CallCenterAlert from "@/components/alert.vue";
import CallCenterLoadingIndicator from "@/components/loadingIndicator.vue";
import CallCenterHeader from "@/components/header.vue";
import CallCenterFooter from "@/components/footer.vue";
export default {
  name: "v-main",
  components: {
    CallCenterAlert,
    CallCenterLoadingIndicator,
    CallCenterHeader,
    CallCenterFooter
  },
  watch: {
    $route() {
      // clear alert on location change
      this.$store.dispatch("alert/clear");
    }
  },
  methods: {
    ...mapActions("authentication", ["logout", "getBaseData"]),
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);

      element.style.height = this.prevHeight;

      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    }
  },
  computed: {
    ...mapState("authentication", ["user"]),
    ...mapState("loadingIndicator", ["loading"]),
    showGlobalElements() {
      const { path, name } = this.$route;

      return path !== "/" && name;
    }
  },
  created() {
    if (this.user) {
      if (!moment(this.user.expires_on).isAfter()) {
        this.logout();
      } else {
        this.getBaseData();
      }
    }
  }
};
</script>
<style lang="scss">
.c-main {
  flex-grow: 1;
}
</style>
